import useSWR from 'hooks/useSWR';

export default id =>
  useSWR({
    url: `/v1/maple_external_transactions/${id}`,
    swrOptions: { if: Boolean(id) }
  });
